/* eslint-disable jsx-a11y/anchor-is-valid */
import Search from "@mui/icons-material/Search";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDoctorsData } from "../../../providers/doctorsData";
import { useFilters } from "../../../providers/filters";
import { UseScrollToTop } from "../../../utils/scroll";
import { getSearchParamsByList } from "../../../utils/searchParams";
import { DatePickerComponent } from "../../Cards/DatePicker";

const MainInput = () => {
  const { searching } = useDoctorsData();
  const [searchParams, setSearchParams] = useSearchParams();

  const { searchInputValue, setSearchInputValue, scrollToList } = useFilters();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    scrollToList.current = true
    if (searchInputValue) {
      searchParams.set("search", searchInputValue);
    } else {
      searchParams.delete("search");
    }
    searchParams.delete("page");  // reset paginação
    setSearchParams(searchParams);
  };

  useEffect(()=>{
    setSearchInputValue(searchParams.get("search") || "");
  },[])

  return (
    <div className="main-search mt-4">
      <div className="main-search-bg">
        <div className="p-0 w-100 h-100 d-flex position-relative">
          <label htmlFor="main-search"><Search className="position-absolute start-0 ms-3 top-50 translate-middle-y" sx={{ color: "action.active" }} /></label>
          <form onSubmit={handleSubmit} className="w-100">
            <input
              id="main-search"
              name="search"
              type="text"
              placeholder="Condição, procedimento ou nome do médico..."
              className="form-control py-3 bg-none px-5 border-0"
              onChange={(e) => setSearchInputValue(e.target.value)}
              value={searchInputValue}
            />
          </form>
          <div className="position-absolute end-0 top-50 translate-middle-y d-flex align-items-center gap-2 pe-1">
            <div className="no-border date-picker-mobile">
              <DatePickerComponent theme="light" />
            </div>
            <button
              type="button"
              onClick={handleSubmit}
              disabled={searching}
              className="btn btn-primary px-2"
            >
              <i className="las la-fw lh-1 la-search"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainInput;
